import { environment as baseEnv } from './environment.dev'

export const environment = {
  ...baseEnv,
  environmentKey: 'dev-alt-15',
  apiUrl: 'https://dev-alt-15-api.eshyft.com/api/v2',
  socketUrl: 'https://dev-alt-15-api.eshyft.com',
  firebaseTenantId: 'dev-alt-15-pte4s',
  verifyOtpUrl: 'https://verify-otp-lgtjqnr75q-uk.a.run.app'
}
